export default __webpack_public_path__ + "static/media/pizza-app.51dface3.png";